/* zk-faq2.js — أسئلة المحتوى */
(function(){
'use strict';
var MAP={luck:['l',5],detox:['d',1],meditations:['m',1],rituals:['r',1],bundle:['b',9]};
var cfg=MAP[window.ZKPAGE];if(!cfg)return;
var PRE=cfg[0],N=cfg[1];
function esc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')}
function item(n,q,a){
  return '<div class="ai"><button class="ah" type="button">'+
    '<span class="n">'+n+'</span><span class="t">'+esc(q)+'</span>'+
    '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>'+
    '</button><div class="ab"><div class="in">'+esc(a)+'</div></div></div>';
}
function closeAll(acc){
  [].slice.call(acc.children).forEach(function(x){
    x.classList.remove('open');
    var ab=x.querySelector('.ab');if(ab)ab.style.maxHeight='';
  });
}
function wire(acc,from){
  [].slice.call(acc.children).slice(from).forEach(function(it){
    var b=it.querySelector('.ah'),ab=it.querySelector('.ab');if(!b||!ab)return;
    b.addEventListener('click',function(){
      var open=it.classList.contains('open');
      closeAll(acc);
      if(!open){
        it.classList.add('open');
        ab.style.maxHeight=(ab.scrollHeight+8)+'px';
      }
    });
  });
}
function build(){
  var app=document.getElementById('app');if(!app)return false;
  var s=(window.ZK&&window.ZK.faq2)||{};
  var rows=[];
  for(var i=1;i<=N;i++){
    var q=s[PRE+'q'+i],a=s[PRE+'a'+i];
    if(q&&a&&String(q).trim()&&String(a).trim())rows.push([String(q),String(a)]);
  }
  if(!rows.length)return true;

  var acc=document.querySelector('#zk .acc');
  if(acc){
    if(acc.getAttribute('data-faq2')==='1')return true;
    var start=acc.children.length,html='';
    rows.forEach(function(r,k){html+=item(start+k+1,r[0],r[1])});
    acc.insertAdjacentHTML('beforeend',html);
    acc.setAttribute('data-faq2','1');
    wire(acc,start);
    return true;
  }

  if(document.getElementById('faq2'))return true;
  var html2='';
  rows.forEach(function(r,k){html2+=item(k+1,r[0],r[1])});
  var sec=document.createElement('section');
  sec.id='faq2';sec.className='sec tint';
  sec.innerHTML='<div class="wrap narrow"><div class="shead c rv">'+
    '<span class="eyebrow">أسئلة تصلنا كثيرًا</span>'+
    '<h2 class="h-1">مضمون الباقة<span class="thin">كل ما تحتاجين معرفته قبل التسجيل</span></h2>'+
    '</div><div class="acc rv">'+html2+'</div></div>';
  var anchor=document.getElementById('sky12');
  if(anchor)anchor.parentNode.insertBefore(sec,anchor.nextSibling);
  else app.appendChild(sec);
  var a2=sec.querySelector('.acc');
  a2.setAttribute('data-faq2','1');
  wire(a2,0);
  var rm=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els=[].slice.call(sec.querySelectorAll('.rv'));
  if(!rm&&'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;e.target.classList.add('in');io.unobserve(e.target)})},{threshold:.08,rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(e){io.observe(e)});
  }else{els.forEach(function(e){e.classList.add('in')})}
  return true;
}
var tries=0;
(function go(){if(build())return;if(++tries>40)return;setTimeout(go,150)})();
})();
